import { useMemo } from 'react';
import { PaymentMethod, PaymentMethodStatus } from '@frontend/api-payment-plans';
import { useTranslation } from '@frontend/i18n';
import { classNames } from '@frontend/string';
import { theme } from '@frontend/theme';
import { Text, Button } from '@frontend/design-system';

export type AchNonVerifiedMessageProps = {
  paymentMethods: PaymentMethod[];
  personId: string;
  invalidatePaymentMethodsByPerson: (patientId?: string, locationId?: string) => void;
  className?: string;
};

export const AchNonVerifiedMessage = ({
  paymentMethods,
  className,
  personId,
  invalidatePaymentMethodsByPerson,
}: AchNonVerifiedMessageProps) => {
  const { t } = useTranslation('payments');

  const hasNonVerifiedAch = useMemo(() => {
    return paymentMethods?.some((pm) => pm.status === PaymentMethodStatus.PAYMENT_METHOD_STATUS_VERIFICATION_PENDING);
  }, [paymentMethods]);

  if (!hasNonVerifiedAch) {
    return null;
  }

  return (
    <div
      className={classNames('payment-methods__ach-non-verified-message', className)}
      css={{ display: 'flex', alignItems: 'center', gap: theme.spacing(1), justifyContent: 'space-between' }}
    >
      <Text size='medium' css={{ fontStyle: 'italic' }}>
        {t('It may take a minute for authorization to show in app. Refresh if needed')}
      </Text>
      <Button
        variant='secondary'
        label={t('Refresh')}
        iconName='update-small'
        onClick={() => {
          invalidatePaymentMethodsByPerson(personId);
        }}
      ></Button>
    </div>
  );
};
